import { Site } from "./index";
import api from "./api";
import { LogoutRequest, LogoutResponse } from "@/components/types";

export abstract class BaseTopMenuBloc {

    async getSite(id: any): Promise<Site> {
        let response = await api.getSite(id)
        return response.data;
    }

    async logout(data: LogoutRequest): Promise<LogoutResponse> {
        let response = await api.logout(data)
        return response.data;
    }

}

